import { RiArrowDownSLine, RiArrowUpSLine } from "@remixicon/react";
import classNames from "classnames";
import React, {
    ReactElement, ReactNode,
    useState,
} from "react";
import { Card } from "react-bootstrap";
import Button from "../theme/button/Button";
import Styles from "./AdvancedSection.module.scss";

export default function AdvancedSection({
    title, children, defaultExpanded, onExpanded, onCollapsed, className, bodyClassName,
}: {
    title: ReactNode;
    defaultExpanded?: boolean;
    children: ReactElement[] | ReactElement | false | undefined | ReactNode;
    onExpanded?: () => void;
    onCollapsed?: () => void;
    className?: string
    bodyClassName?: string;

}): ReactElement {
    const [isExpanded, setExpanded] = useState(defaultExpanded);

    const toggle = () => {
        setExpanded(current => !current);
        if (isExpanded) {
            onCollapsed?.();
        } else {
            onExpanded?.();
        }
    };
    return (
        <Card className={classNames(Styles.card, "advanced-section", className)}>
            <Card.Title
                className={classNames()}
            >
                <Button
                    onClick={toggle}
                    variant="none"
                    className={Styles.toggle}
                    prefixIcon={isExpanded
                        ? <RiArrowUpSLine />
                        : <RiArrowDownSLine />}
                >
                    {title}
                </Button>

            </Card.Title>
            {isExpanded && (
                <Card.Body className={classNames(Styles["card-body"], bodyClassName)}>
                    {children}
                </Card.Body>
            )}
        </Card>
    );
}
AdvancedSection.defaultProps = {
    defaultExpanded: false,
    onExpanded: undefined,
    onCollapsed: undefined,
    className: undefined,
    bodyClassName: undefined,
};
